import styled from "styled-components/macro";

export const Header = styled.header`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  //backdrop-filter: blur 2px;
  z-index: 999;
`;

export const Nav = styled.nav`
  //width: 100%;
  display: flex;
  justify-content: space-between;
  height: 100%;
  position: relative;
  height: 5rem;
  align-items: center;
`;

export const LogoContainer = styled.div`
  height: 3rem;
  margin: auto 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const Logo = styled.img`
  height: 100%;
  width: auto;
`;

export const NavList = styled.ul`
  display: flex;
  list-style: none;
  height: 100%;
  @media (max-width: 820px) {
    flex-direction: column;
    position: absolute;
    height: auto;
    top: 100%;
    left: 0;
    width: 100%;
    max-height: 0;
    overflow-y: scroll;
    transition: max-height 0.5s ease;
    background: #eeeeee25;
    background: #fbfbfb;

    li {
      border-bottom: 1px solid rgba(256, 256, 256, 0.2);

      a {
        color: var(--main-black);
      }
    }
    &.open {
      max-height: 300px;
    }
  }
`;

export const NavItem = styled.li`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &:not(:last-child) {
    padding-right: 1rem;
  }
`;

export const NavLink = styled.a`
  height: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #030303;
  padding: 0 1rem;

  cursor: pointer;
  position: relative;
  font-size: 0.9rem;
  letter-spacing: 1px;
  white-space: nowrap;
  ${(props) =>
    props.isActive
      ? `
        &::before{
            position: absolute;
            top: 80%;
            
            content:"";
            width: 1ch;
            height: 3px;
            background: #08B21C;
            //transition: width 0.1s ease;
            }
        &:hover{
            @media (min-width: 769px){
                /*&::before {
                width:calc(100% - 2rem );*/
                color:#08B21C;
            }
            }
        }
        `
      : `&::before{
            position: absolute;
            top: 80%;
            
            content:"";
            width: 0;
            height: 3px;
            background: #08B21C;
            //transition: width 0.1s ease;
            }
        &:hover{

            @media (min-width: 769px){
                /*&::before {
                width:calc(100% - 2rem );
            }*/
            color:#08B21C;
            }

        }

        
        `};

  @media (max-width: 820px) {
    &::before {
      ${(props) =>
        props.isActive
          ? `
            height: 100%;
			width: .5ch;
            `
          : `
            height:0;
            width: 0;
            `} top: 0;

      left: 0;
    }
    padding: 1rem 0;
    width: 100%;
    justify-content: flex-start;
    padding-left: 1rem;
  }
`;
export const BurgerLabel = styled.label`
  display: none;

  @media (max-width: 820px) {
    display: block;
    align-self: center;
  }
`;

export const BurgerContainer = styled.div`
  height: 2rem;
  width: 2rem;
  position: relative;
  cursor: pointer;
`;

export const Burger = styled.div`
  width: 18px;
  height: 2px;
  background: #08b21c;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: 0.2s;
  &.open {
    background: transparent;
  }
  &::before {
    top: 6px;
  }
  &::after {
    top: -6px;
  }
  &::before,
  &::after {
    background: #08b21c;
    content: "";
    width: 18px;
    height: 2px;
    position: absolute;

    transition: 0.2s;
  }

  &.open::before {
    top: 0;

    transform: rotate(135deg);
  }
  &.open::after {
    top: 0;

    transform: rotate(45deg);
  }
`;

export const BurgerCheckbox = styled.input`
  display: none;
`;
